import { showToast } from '@shopee/web-bridge-sdk'
import { AxiosError, AxiosResponse } from 'axios'
import Axios from 'axios-settings'
import { COMMON_ERROR_CODE, LOGIN_ERROR_CODE, NETWORK_ERROR_CODE, NON_AFFILIATE_CODE } from 'shared/constants'
import { navigateToUrl } from 'shared/helpers'

export const configAxios = () => {
  const showError = (content?: string) => {
    showToast({ toast: { iconType: 'failure', message: content || 'Đã có lỗi xảy ra, vui lòng thử lại' } })
  }

  const interceptorResponse = (response: AxiosResponse) => {
    if (response?.data?.code !== 0) {
      const pathName = window.location.pathname.replace(process.env.SUB_PATH || '', '')
      if (response?.data?.code === NON_AFFILIATE_CODE && !!pathName && pathName !== '/') {
        navigateToUrl(process.env.BASE_URL, true)
      } else {
        showError()
      }
      return Promise.reject({
        msg: response?.data?.msg || 'Api failed',
        code: response?.data?.code,
      })
    }

    if (response?.data) {
      return response.data
    }

    showError()
    return Promise.reject({
      msg: 'Api failed',
      code: COMMON_ERROR_CODE,
    })
  }

  const interceptorResponseError = (error: AxiosError) => {
    if (!window.navigator.onLine) {
      showError()

      return Promise.reject({ msg: 'network error', code: NETWORK_ERROR_CODE })
    }
    if (error.response && error.response.status === LOGIN_ERROR_CODE) {
      return Promise.reject({ msg: error, code: LOGIN_ERROR_CODE })
    }

    showError()
    return Promise.reject({ msg: error, code: error?.response?.status || COMMON_ERROR_CODE })
  }

  Axios.interceptors.response.use(interceptorResponse, interceptorResponseError)
}
